// extracted by mini-css-extract-plugin
export default {"wrapper":"HouseModel_wrapper__vnJ5v"};